import React, { useState } from "react";
import Text from "../Text";
import moment from "moment";
import { getStaticImg } from "../../../utils/function";
import { useFetchScheduleMatch } from "../../../networks";
import "moment/locale/id";
import { useEffect } from "react";
import { usePageContextState } from "../../../context/PageContext";
import classNames from "classnames";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;
/**
 * @deprecated
 * You can use ScheduleCardNew Component
 */
const ScheduleCard = ({ activeCard = "basketSchedule" }) => {
  const { city } = usePageContextState();
  const [firstRenderTab, setIsFirstRenderTab] = useState(true);
  const [activeTab, setActiveTab] = useState(-1);
  const { data: dataMatch } = useFetchScheduleMatch(city, !!city);
  const isHighSchool = activeCard?.includes("sma");

  const isDance = activeCard.includes("dance");

  const dataSchedule = dataMatch?.data?.data ?? [];

  /* Mapping Data */
  const dataItems = dataSchedule?.[activeCard];

  const cardSchedule = Object.keys({ ...dataItems });
  const activeItems = cardSchedule[activeTab];

  const dateParser = (dateTime) => {
    const theDate = moment(dateTime).format("dddd-DD-MMMM").split("-");
    const day = theDate[0];
    const date = theDate[1];
    const month = theDate[2];

    return { day, date, month };
  };

  const _renderDanceCard = () => {
    const danceDate = [
      "Tue Oct 22 2022 07:00:00 GMT+0700 (Western Indonesia Time)",
      "Wed Oct 23 2022 07:00:00 GMT+0700 (Western Indonesia Time)",
    ];

    return Array(2)
      .fill()
      .map((_, idx) => {
        const { day, date, month } = dateParser(danceDate[idx]);
        return (
          <ScheduleCardItem
            key={idx}
            day={day}
            date={date}
            month={month}
            status={"inactive"}
            setActiveTab={setActiveTab}
            isDisabled={true}
          />
        );
      });
  };

  const _renderCard = (data, index, status = "active") => {
    const { day, date, month } = dateParser(data);

    const theStatus =
      status === "active" ? (isHighSchool ? "activeSma" : "activeSmp") : status;

    return (
      <>
        <ScheduleCardItem
          key={index}
          index={index}
          day={day}
          date={date}
          month={month}
          status={theStatus}
          setActiveTab={setActiveTab}
          isDisabled={false}
        />
      </>
    );
  };

  const getScheduleTabPosition = (data = []) => {
    const todayDate = moment(new Date()).format().substring(0, 10);
    const activeDate = [...data].filter((data) => {
      return data >= todayDate;
    });
    const activeIndex = [...data].indexOf(activeDate[0]);

    return activeIndex;
  };

  useEffect(() => {
    if (cardSchedule.length > 0 && firstRenderTab) {
      const activeScheduleTab = getScheduleTabPosition(cardSchedule);

      setActiveTab(activeScheduleTab);
      setIsFirstRenderTab(false);
    }
  }, [firstRenderTab, cardSchedule]);

  useEffect(() => {
    setIsFirstRenderTab(true);
  }, [activeCard]);

  return (
    <div
      className={classNames("schedule-card", {
        smpBgColor: !isHighSchool,
        smaBgColor: isHighSchool,
      })}
    >
      <div className="schedule-card__card-container">
        {isDance && _renderDanceCard()}
        {cardSchedule.map((data, index) =>
          _renderCard(data, index, activeTab === index ? "active" : "inactive")
        )}
      </div>
      <div className={"schedule-card__jadwal-pertandingan-container"}>
        <img
          alt="Default Image"
          src={
            dataItems?.[activeItems]
              ? `${imgPath}/${dataItems?.[activeItems]?.[0]?.key_visual}`
              : getStaticImg("/illustration/default-image.png")
          }
        />
      </div>
    </div>
  );
};

const ScheduleCardItem = ({
  index,
  day,
  date,
  month,
  status,
  setActiveTab,
  isDisabled,
}) => (
  <div
    onClick={() => {
      if (!isDisabled) setActiveTab(index);
    }}
    key={index}
    className={`schedule-card__card-container__card ${
      isDisabled ? "disabled-schedule" : status
    }`}
  >
    <Text
      className={`schedule-card__card-container__title ${
        isDisabled ? "disabled-inactive" : status !== "active" && status
      }`}
    >
      {day}
    </Text>
    <Text
      className={`schedule-card__card-container__date ${
        isDisabled ? "disabled-inactive" : status !== "active" && status
      }`}
    >
      {date}
    </Text>
    <Text
      className={`schedule-card__card-container__month ${
        isDisabled ? "disabled-inactive" : status !== "active" && status
      }`}
    >
      {month}
    </Text>
  </div>
);

export default ScheduleCard;
